import 'bootstrap-icons/font/bootstrap-icons.css';
import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { routeData } from "./routes/Routes";
import NotFound from "./components/NotFoundPage";
import "./styles/_main.scss";
import { useDispatch, useSelector } from "react-redux";
import { refereshToken } from './services/auth/tokens';
import { updateToken } from './redux/action/login.action';
import Loader from './components/Loader';
import ErrorBoundary from './components/ErrorBoundary';
import './utils/patchResizeObserver';

const App = () => {
  const navigate = useNavigate();
  const { isLogin, tokens } = useSelector(state => state.login);
  const [routes, setRoutes] = useState(routeData(isLogin));
  const refreshTime = Number(process.env.REACT_APP_REFRESH_TOKEN_TIME) || 600000;
  const dispatch = useDispatch();
  const { loading, variant } = useSelector((state) => state.loader);

  useEffect(() => {
    
    setRoutes(routeData(isLogin));
  }, [navigate, isLogin]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (tokens?.accessToken) {
        refereshToken(tokens?.refreshToken)
          .then((data) => {
            dispatch(updateToken(data));
          })
          .catch((err) => {
            console.error('Refresh token failed:', err);
          });
      }
    }, refreshTime);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokens?.accessToken]);

  return (
    <ErrorBoundary>
      {loading && <Loader variant={variant} />}
      
      <Routes>
        {routes?.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {route.nestedRoutes &&
              route.nestedRoutes.map((nestedRoute, nestedIndex) => (
                <Route
                  key={nestedIndex}
                  path={nestedRoute.path}
                  element={nestedRoute.element}
                />
              ))}
          </Route>
        ))}
        {/* Catch Invalid Routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
